module.exports = __webpack_public_path__ + "media/01 aristocrat.eaa25afb.mp3";